export const menuOptions = [
    { label: "edit", value: "edit" },
    { label: "delete", value: "delete" }
];
export const menuDelete = [
    { label: "delete", value: "delete" }
];

